import Image from 'next/image';
import Link from 'next/link';
import React from 'react';

const OurOfferingDataEngineering = () => {
    return (
        <div className="section-py !pb-0 dark:bg-black">
            <div className="container lg:container mx-auto">
                <div className="row grid lg:grid-cols-12">
                    <div className="lg:col-span-10 pb-10">
                        <h2 className="mb-0 dark:text-white" data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
                            Our Data Engineering & Foundation Offerings 
                        </h2>
                    </div>
                </div>
                <div className="row grid xl:grid-cols-5 lg:grid-cols-5 md:grid-cols-2 mb-10">
                    <div className="card p-5 dark:bg-[#3C45611A] dark:border-[#ffffff33] dark:border-solid">
                        <div className="voice-generator-box mb-3">
                            <Image src="/img/ai-agent/svg/ic-agent-design.svg" width={36} height={36} alt="Agent design" />
                        </div>
                        <p className="fs-md mb-0 fw-500 dark:text-[#D7DEE5]">Data pipeline development with ETL/ELT automation & orchestration frameworks</p>
                    </div>
                    <div className="card p-5 dark:bg-[#3C45611A] dark:border-[#ffffff33] dark:border-solid">
                        <div className="voice-generator-box mb-3">
                            <Image src="/img/ai-agent/svg/ic-mcp-server.svg" width={36} height={36} alt="MCP server-client setup" />
                        </div>
                        <p className="fs-md mb-0 fw-500 dark:text-[#D7DEE5]">
                            Data warehouse architecture design & implementation with Snowflake, Redshift, and BigQuery
                        </p>
                    </div>
                    <div className="card p-5 dark:bg-[#3C45611A] dark:border-[#ffffff33] dark:border-solid">
                        <div className="voice-generator-box mb-3">
                            <Image
                                src="/img/ai-agent/svg/ic-multi-agent.svg"
                                width={36}
                                height={36}
                                alt="Multi-agent workflow"
                            />
                        </div>
                        <p className="fs-md mb-0 fw-500 dark:text-[#D7DEE5]">
                            Data lake & lakehouse platforms such as Databricks, Delta Lake, and AWS S3a
                        </p>
                    </div>
                    <div className="card p-5 dark:bg-[#3C45611A] dark:border-[#ffffff33] dark:border-solid">
                        <div className="voice-generator-box mb-3">
                            <Image
                                src="/img/ai-agent/svg/ic-action-validation.svg"
                                width={36}
                                height={36}
                                alt="Action validation"
                            />
                        </div>
                        <p className="fs-md mb-0 fw-500 dark:text-[#D7DEE5]">
                            Real-time streaming data pipelines like Kafka, Kinesis, Pub/Suba, and Flink
                        </p>
                    </div>
                    <div className="card p-5 dark:bg-[#3C45611A] dark:border-[#ffffff33] dark:border-solid">
                        <div className="voice-generator-box mb-3">
                            <Image
                                src="/img/ai-agent/svg/ic-secure-audit.svg"
                                width={36}
                                height={36}
                                alt="Secure audit"
                            />
                        </div>
                        <p className="fs-md mb-0 fw-500 dark:text-[#D7DEE5]">
                            Cloud data platform migration, data modeling, schema design & optimization
                        </p>
                    </div>
                </div>
                <div className="row grid xl:grid-cols-5 lg:grid-cols-5 md:grid-cols-2 mb-[50px]">
                    <div className="card p-5 dark:bg-[#3C45611A] dark:border-[#ffffff33] dark:border-solid">
                        <div className="voice-generator-box mb-3">
                            <Image
                                src="/img/ai-agent/svg/ic-agent-monitoring.svg"
                                width={36}
                                height={36}
                                alt="Agent monitoring"
                            />
                        </div>
                        <p className="fs-md mb-0 fw-500 dark:text-[#D7DEE5]">
                            Data quality frameworks with validation, monitoring & anomaly detection
                        </p>
                    </div>
                    <div className="card p-5 dark:bg-[#3C45611A] dark:border-[#ffffff33] dark:border-solid">
                        <div className="voice-generator-box mb-3">
                            <Image
                                src="/img/ai-agent/svg/ic-agent-accelerators.svg"
                                width={36}
                                height={36}
                                alt="Agent accelerators"
                            />
                        </div>
                        <p className="fs-md mb-0 fw-500 dark:text-[#D7DEE5]">
                            Master data management & data cataloging solutions implementation
                        </p>
                    </div>
                    <div className="card p-5 dark:bg-[#3C45611A] dark:border-[#ffffff33] dark:border-solid">
                        <div className="voice-generator-box mb-3">
                            <Image src="/img/ai-agent/svg/ic-mcp-protocol.svg" width={36} height={36} alt="MCP protocol" />
                        </div>
                        <p className="fs-md mb-0 fw-500 dark:text-[#D7DEE5]">
                            DataOps automation with CI/CD pipelines for data workflows
                        </p>
                    </div>
                    <div className="card p-5 dark:bg-[#3C45611A] dark:border-[#ffffff33] dark:border-solid">
                        <div className="voice-generator-box mb-3">
                            <Image
                                src="/img/ai-agent/svg/ic-custom-data-indexing.svg"
                                width={36}
                                height={36}
                                alt="Custom data indexing"
                            />
                        </div>
                        <p className="fs-md mb-0 fw-500 dark:text-[#D7DEE5]">
                           Data integration connecting databases, APIs, files & SaaS applications
                        </p>
                    </div>
                    <div className="card p-5 dark:bg-[#3C45611A] dark:border-[#ffffff33] dark:border-solid">
                        <div className="voice-generator-box mb-3">
                            <Image src="/img/ai-agent/svg/ic-hybrid-rpa-ai.svg" width={36} height={36} alt="Hybrid RPA-AI" />
                        </div>
                        <p className="fs-md mb-0 fw-500 dark:text-[#D7DEE5]">
                            Data governance frameworks, including lineage, security & compliance controls
                        </p>
                    </div>
                </div>
                <div className="row grid lg:grid-cols-12 bg-ready-transform rounded-10 relative">
                    <div className="counter-overlay"></div>
                    <div className="lg:col-span-12 lg:p-12 md:p-5 p-5 relative z-[1]">
                        <h2 className="mb-3 text-white">Ready to Transform Your Enterprise Knowledge into Intelligent Action?</h2>
                        <p className="mb-3 text-white">
                            Request a demo to see production-ready RAG pipelines and enterprise chatbots in action
                        </p>
                        <div>
                            <Link href="/contact-us" className="btn btn-primary">
                                {'Schedule a call with us'}
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OurOfferingDataEngineering;
